module.exports = __webpack_public_path__ + "img/view2.70aa2dcc.png";